<script>
    import Fa from 'svelte-fa';
    import { faMoonCloud, faSunBright } from '@fortawesome/pro-regular-svg-icons';

    import { page } from '$app/stores';
    import { onMount } from 'svelte';
    import { invalidateAll } from '$app/navigation';

    export let classes;

    let currentTheme = $page.data?.userPreferences?.siteTheme;

    function toggleTheme() {
        const theme = currentTheme === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', theme);

        const themeColor = currentTheme === 'dark' ? '#f4f4f9' : '#090712';
        document.querySelector('meta[name="theme-color"]').setAttribute('content', themeColor);

        const cookieWindow = 60 * 60 * 24 * 365;
        document.cookie = `theme=${theme}; max-age=${cookieWindow}; path=/`;

        currentTheme = theme;
        invalidateAll();
    }

    onMount(() => {
        if (currentTheme === 'dark' || (!currentTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
            currentTheme = 'dark';
        } else {
            currentTheme = 'light';
        }
    });
</script>

<button aria-label="Toggle dark and light mode" on:click={toggleTheme} class={classes}>
    {#if currentTheme === 'dark'}
        <Fa icon={faSunBright} />
    {:else}
        <Fa icon={faMoonCloud} />
    {/if}
</button>
